//todo refactor this out
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SearchReceipt from './results/searchReceipt/SearchReceipt';
import ResultsTable from './results/dataTable/resultsTable/ResultsTable';
import Loading from '../common/Loading';

import NoResults from '../common/NoResults';


class SearchResults extends Component {
  render() {
    const searchReceipts = this.props.pacerSearchResults.get('receipts')
      .map((receipt, idx) => <SearchReceipt key={idx} receipt={receipt} />);

    const searchResultsType = this.props.pacerSearchResults.get('searchResultsType');

    const hasValidReceipt =
      this.props.pacerSearchResults.get('receipts')
        .filter(receipt => !! receipt.getIn(['text', 'description']))
        .size > 0;

    const results = searchResultsType == 'empty'
      ? (hasValidReceipt && <NoResults />)
      : <ResultsTable />;

    return (
      <div id="pacer-search-results">
        <div className="ir-search-items">

          {results}

          <Loading />

          {searchReceipts}

        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pacerSearchResults: state.get('pacerSearchResults')
  };
}

export default connect(mapStateToProps)(SearchResults);



// WEBPACK FOOTER //
// ./src/components/search/SearchResults.js